(function() {
    

    let allSwipers = [];

    window.initAllSwipers = (container = document) => {
        
        allSwipers = allSwipers.filter(s => s && s.el && s.el.isConnected);

        let defaultSettings = {
            loop: false,
            speed: 1000,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            init: false,
        };

         container.querySelectorAll('.js-swiper').forEach((element, i) => {
            if (element.swiper){
                const staleIndex = allSwipers.indexOf(element.swiper);
                if (staleIndex > -1) allSwipers.splice(staleIndex, 1);
                if (element._autoHeightObserver) element._autoHeightObserver.disconnect();
                element.swiper.destroy(true, true);
            } 

            let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultSettings;
            let combinedOps = Object.assign({}, defaultSettings, swiperConfig);

            if (swiperConfig.modules) delete swiperConfig.modules;
            
            element.setAttribute(`data-swiper-id-${i}`, '');
            
            // --- CUSTOM DOTS ---
            if(combinedOps.pagination){
                const isCounter = combinedOps.pagination.isCounter;
                
                const yearsArr = combinedOps.pagination.years; 
                const extraClasses = combinedOps.pagination.counterClasses || "";

                combinedOps.pagination.renderBullet = function(index, className){
                    let slideNumber = (index + 1).toString().padStart(2, '0');

                    if (yearsArr && yearsArr.length > 0) {
                        let yearLabel = yearsArr[index] || '';
                        return `<button class="${className} bullet-is-year flex-box column a-center j-center" aria-label="${yearLabel} Go to slide">
                                    <span class="year-label">${yearLabel}</span>
                                    <span class="timeline-node"></span>
                                </button>`;
                    }
                    else if (isCounter) {
                        return `<button class="${className} bullet-is-number flex-box a-center j-center ${extraClasses}" aria-label="${slideNumber} Go to slide">
                                    <span class="bullet-number no-margin-bottom">${slideNumber}</span>
                                    <span class="progress-line"></span>
                                </button>`;
                    } 
                    else {
                        return `<button class="${className} bullet-is-dot" aria-label="${slideNumber} Go to slide">
                                    <span class="hidden">${slideNumber}</span>
                                </button>`;
                    }
                } 
            }

            let swiper = new Swiper(element, combinedOps);
            
            // --- TABS ---
            const elementId = element.getAttribute('id');
            if (elementId) {
                const allTabs = document.querySelectorAll(`[data-swiper-tabs="#${elementId}"]`);
                if (allTabs.length > 0) {
                    allTabs.forEach(tab => {
                        tab.addEventListener('click', (e) => {
                            e.preventDefault();
                            const index = parseInt(tab.getAttribute('data-swiper-goto'));
                            if (!isNaN(index)) swiper.slideTo(index);
                        });
                        tab.addEventListener('keydown', (e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                tab.click();
                            }
                        });
                    });
                    swiper.on('slideChange', () => {
                        const currentIndex = swiper.realIndex;
                        allTabs.forEach(tab => {
                            const tabIndex = parseInt(tab.getAttribute('data-swiper-goto'));
                            tab.classList.toggle('active', tabIndex === currentIndex);
                        });
                    });
                }
            }
            // Accessibility for Swiper images (multiple images)
            const updateSingleSliderFocus = (swiperInstance) => {
                setTimeout(() => {
                    if (!swiperInstance || swiperInstance.destroyed) return;
                     const slides = swiperInstance.slides ? Array.from(swiperInstance.slides) : [];
                        slides.forEach((slide) => {
                            const isActive = slide.classList.contains('swiper-slide-visible');
                            const focusableElements = slide.querySelectorAll('a, button, [tabindex="0"]');
                            
                            focusableElements.forEach(el => {
                                if (
                                    el.classList.contains('list-block__no-expand') ||
                                    el.classList.contains('columns-block__no-expand') ||
                                    el.classList.contains('rooms-block__no-expand') ||
                                    el.classList.contains('venues-block__no-expand') ||
                                    el.classList.contains('tabs-block__no-expand')

                                ) {
                                    el.setAttribute('tabindex', '-1');
                                    return;
                                }
                                if (isActive) {
                                    el.removeAttribute('tabindex');
                                } else {
                                    el.setAttribute('tabindex', '-1');
                                }
                            });
                        });
                }, 50);
            };

            if (combinedOps.autoHeight) {
                const fixHeight = () => {
                    requestAnimationFrame(() => {
                        if (
                            !swiper ||
                            swiper.destroyed ||
                            !swiper.params ||
                            !swiper.params.autoHeight ||
                            typeof swiper.updateAutoHeight !== 'function'
                        ) return;

                        swiper.updateAutoHeight(combinedOps.speed || 300);
                    });
                };

                swiper.on('init', fixHeight);
                swiper.on('imagesReady', fixHeight);
                swiper.on('slideChangeTransitionEnd', fixHeight);
                swiper.on('breakpoint', fixHeight);   
                swiper.on('resize', fixHeight);  

                if (document.fonts) document.fonts.ready.then(fixHeight);
                element.querySelectorAll('img').forEach(img => {
                    if (!img.complete) img.addEventListener('load', fixHeight, { once: true });
                });
            }
            swiper.on('slideChange', () => {
                updateSingleSliderFocus(swiper);
            });

            swiper.on('init', () => {
                updateSingleSliderFocus(swiper);
            });

            swiper.init();
            allSwipers.push(swiper);
        });

        // ---  SINCRONIZACIÓN ---
        allSwipers.forEach((mainSwiper) => {
            const targetSelector = mainSwiper.params.customcontrol;
            if (targetSelector) {
                const selectorClean = targetSelector.startsWith('#') ? targetSelector : `#${targetSelector}`;
                let targetElement = null;
                try { targetElement = document.querySelector(selectorClean); } catch(e) {}
                if (targetElement) {
                    const targetSwiper = allSwipers.find(s => s.el === targetElement);
                    // if (targetSwiper) {
                    //     const isLoopEnabled = mainSwiper.params.loop;
                    //     const syncHeightTarget = () => {
                    //         if (targetSwiper.params.autoHeight) {
                    //             setTimeout(() => targetSwiper.updateAutoHeight(mainSwiper.params.speed || 300), 100);
                    //         }
                    //     };

                    //     if (isLoopEnabled) {
                    //         const sync = (source, target) => {
                    //             source.on('slideChange', () => {
                    //                 if (target.realIndex !== source.realIndex) {
                    //                     target.slideToLoop(source.realIndex, source.params.speed);
                    //                     syncHeightTarget();
                    //                 }
                    //             });
                    //         };
                    //         sync(mainSwiper, targetSwiper);
                    //         if (targetSwiper.params.allowTouchMove) sync(targetSwiper, mainSwiper);
                    //     } 
                    //     else {
                    //         mainSwiper.controller.control = targetSwiper;
                    //         if (targetSwiper.params.allowTouchMove) targetSwiper.controller.control = mainSwiper;
                        
                    //         mainSwiper.on('slideChange', syncHeightTarget);
                    //     }

                    // }
                    if (targetSwiper) {
                        const syncHeightTarget = () => {
                            if (targetSwiper.params.autoHeight) {
                                setTimeout(() => targetSwiper.updateAutoHeight(mainSwiper.params.speed || 300), 100);
                            }
                        };
                        //Accessibility
                        const updateSlideFocus = (swiperInstance) => {
                            if (!swiperInstance || !swiperInstance.slides) return;
                            swiperInstance.slides.forEach((slide) => {
                                const isActive = slide.classList.contains('swiper-slide-active');
                                const focusableElements = slide.querySelectorAll('a, button, [tabindex="0"]');
                                
                                focusableElements.forEach(el => {
                                    if (isActive) {
                                        el.removeAttribute('tabindex');
                                    } else {
                                        el.setAttribute('tabindex', '-1');
                                    }
                                });
                            });
                        };

                        const eitherLooped = mainSwiper.params.loop || targetSwiper.params.loop;

                        if (eitherLooped) {
                            const sync = (source, target) => {
                                source.on('slideChange', () => {
                                    const idx = source.realIndex;
                                    
                                    if (target.params.loop) {
                                        if (target.realIndex !== idx) {
                                            target.slideToLoop(idx, 0);
                                        }
                                    } 
                                    else {
                                        if (target.activeIndex !== idx) {
                                            target.slideTo(idx, 0);
                                        }
                                    }
                                    syncHeightTarget();
                                    updateSlideFocus(source);
                                    updateSlideFocus(target);
                                });
                                updateSlideFocus(source);
                            };
                            sync(mainSwiper, targetSwiper);
                            if (targetSwiper.params.allowTouchMove) {
                                sync(targetSwiper, mainSwiper);
                            }
                        } 
                        else {
                            mainSwiper.controller.control = targetSwiper;
                            if (targetSwiper.params.allowTouchMove) {
                                targetSwiper.controller.control = mainSwiper;
                            }
                            
                            mainSwiper.on('slideChange', () => {
                                syncHeightTarget();
                                updateSlideFocus(mainSwiper);
                                updateSlideFocus(targetSwiper);
                            });
                        }
                        updateSlideFocus(mainSwiper);
                        updateSlideFocus(targetSwiper);
                    }
                }
            }
        });
    };

    document.addEventListener('DOMContentLoaded', () => {
        window.initAllSwipers();
    });

})();
